module.exports = __webpack_public_path__ + "media/images/icon-card/icon-card-01-0866ce7df01f1d41a2ac57e5bb32f9d0.svg";